<div class="header-secondary">
  <div class="breadcrumbs-container">
    <p-breadcrumb *ngIf="display$ | async" [model]="items$ | async" styleClass="breadcrumbs"></p-breadcrumb>
  </div>
  <div class="user-details-container">
    <z-user-customer></z-user-customer>
    <z-user-facility></z-user-facility>
  </div>
</div>
